import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "TumiPortalNavbar" }
const _hoisted_2 = { class: "container pt-1 pb-1 text-white" }
const _hoisted_3 = { class: "mt-1 float-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, "Welcome, " + _toDisplayString(_ctx.GetLogin()), 1),
      _createElementVNode("button", {
        class: "btn btn-sm btn-primary float-end",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Logout && _ctx.Logout(...args)))
      }, "Logout"),
      _hoisted_4,
      _hoisted_5
    ])
  ]))
}